import LabelBackground from '@/components/LabelBackground/LabelBackground';
import IdeaIcon from '@/components/Icon/IdeaIcon';
import { motion } from 'framer-motion';

const CameraTip = ({ tip }: { tip?: string }) => {
	if (!tip) return null;

	return (
		<motion.div
			className="px-8 sm:px-0"
			initial={{
				opacity: 0,
				y: 0,
			}}
			animate={{
				opacity: [0, 1, 1, 1],
				y: [0, '10vh', '10vh', 0],
				transition: {
					delay: 1,
					duration: 2.5,
				},
			}}
		>
			<p role="alert" className="relative w-full p-4 text-base">
				<LabelBackground className="-scale-x-100 text-secondary" />
				<span className="relative z-30 inline-flex gap-1">
					<IdeaIcon className="size-6 shrink-0 -rotate-6 lg:size-6" />
					{tip}
				</span>
			</p>
		</motion.div>
	);
};

export default CameraTip;
